<section [class.is-expanded-menu]="isExpandMenu$ | async" class="navigation-container flex-col">
  <ng-content></ng-content>
</section>
